<template>
<textarea class="form-control" @input="$emit('input', $event.target.value)">{{ value }}</textarea>
</template>

<script>
export default {
  props: {
    value: {required: true}
  }
}
</script>



// WEBPACK FOOTER //
// TextareaInput.vue?4c8a6721